export default __webpack_public_path__ + "static/media/market-moving-news.f2132cf3.png";